import { useMainSelector } from '../../useMainSelector';

export const useLanguage = () => {
  const {
    designer: { blockLanguage, blockLanguages },
  } = useMainSelector();

  return {
    language: blockLanguage,
    languages: blockLanguages,
  };
};
